<template>
  <v-container>
    <v-layout column>
      <h2 class="headline">Listing Form Constructor</h2>
      <FormConstructor formType='listing_registration'/>
    </v-layout>
  </v-container>
</template>

<script>
  import FormConstructor from '@/components/shared/EvFormConstructor'

  export default {
    name: 'listing-form',
    components: {
      FormConstructor
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Listing/ListingSettings/listingFormConstructor.vue